import React, { useState } from 'react';
import "./style.css";
import UserInformation from './UserInformation'
import defaultImage from "../../assets/defaultImage.png";
import {
  Grid,
  Typography,
  Icon
} from "@mui/material";
import EditIcon from "@mui/icons-material/EditOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Footer from './Footer';
import ImageIcon from '@mui/icons-material/Image';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const UserProfile = ({ handleUserProfile }) => {
  const [profilePic, setProfilePic] = useState(defaultImage);
  const [inEditMode, setProfileEditMode] = useState(false);

  const handleEditClick = (value) => {
    setProfileEditMode(value)
  }

  const handleBackIcon = () => {
    handleUserProfile(false)
  }

  const handleProfilePicChange = (e) => {
    const files = e.target.files;
    setProfilePic(URL.createObjectURL(files[0]));
  };

  const handleProfileDeletetion = (e) => {
    setProfilePic(defaultImage);
  }
  return (
    <>
      <Grid display='flex' flexDirection='column' className="user-profile">
        <Grid display='flex' style={{ marginLeft: '175px', marginTop: '30px' }}>
          <ArrowBackIcon
            onClick={handleBackIcon}
            style={{ fontSize: "20", color: "#0d4f57", justifyContent: "left", }} />
          <Typography style={{ color: '#888888', paddingLeft: '10px' }}>User Profile</Typography>
        </Grid>
        <Grid display='flex' style={{ marginLeft: '190px', marginTop: '20px' }}>
          <Typography style={{ fontSize: '16px', color: '#202121', marginRight: '390px' }}>User Information</Typography>

          {!inEditMode ? <Grid display='flex'>
            <EditIcon
              style={{
                fontSize: "15",
                color: "#0D5C75",
                marginRight: '5px'
              }}
              onClick={() => { handleEditClick(true) }}
            />
            <Typography style={{ fontSize: '12px', color: '#0D5C75' }}>Edit Profile</Typography>
          </Grid> : null}
        </Grid>
        <Grid display='flex' style={{ justifyContent: 'center', marginTop: '5px' }}>
          <UserInformation inEditMode={inEditMode}handleEditClick={handleEditClick}/>
          <Grid className="img-container">
            <img
              src={profilePic}
              className="profileImage"
              alt=""
            />
            {inEditMode && <div
              display="flex"
              style={{ marginTop: '-40px', marginLeft: '100px' }}
            >
              <label htmlFor="uploadDoc_icon">
                <Icon className="picture">
                  <ImageIcon />
                </Icon>
              </label>
              <input
                id="uploadDoc_icon"
                accept="image/*"
                type="file"
                name="file"
                onChange={(e) => handleProfilePicChange(e)}
              />
              <Icon onClick={handleProfileDeletetion} className="delete">
                <DeleteOutlineIcon />
              </Icon>
            </div>}
          </Grid>
        </Grid>
      </Grid>
      {/* {inEditMode ? <Footer handleEditClick={handleEditClick} /> : null} */}
    </>
  );
};

export default UserProfile;